import { Injectable } from "@angular/core";
import { HttpBackend, HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { AppConfig } from "../../../models/app.config.model";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private config: AppConfig | null = null;
  private readonly CONFIG_URL = "/assets/config/config.json";
  handler: HttpBackend;

  constructor(private httpBackend: HttpBackend) {
    this.handler = httpBackend;
  }

  public async loadConfigurations(): Promise<any> {
    const client = new HttpClient(this.handler);
    const config = await firstValueFrom(client.get<AppConfig>(this.CONFIG_URL));
    this.config = config;
  }

  getConfigProperty<K extends keyof AppConfig>(key: K): AppConfig[K] | null {
    return this.config?.[key] ?? null;
  }
}
